import { render, staticRenderFns } from "./MoleculeDownloadBrochure.vue?vue&type=template&id=b0fe3654&"
import script from "./MoleculeDownloadBrochure.vue?vue&type=script&lang=js&"
export * from "./MoleculeDownloadBrochure.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeDownloadBrochure.vue?vue&type=style&index=0&id=b0fe3654&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeDownloadBrochure.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FMoleculeDownloadBrochure.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomInput: require('/app/components/atoms/common/AtomInput.vue').default,AtomsCommonAtomCheck: require('/app/components/atoms/common/AtomCheck.vue').default})
